import React, { useState } from 'react'
import LandingWrapper from './LandingWrapper'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import { FaUserCircle } from 'react-icons/fa'
import './styles.css'

export default function LandingReference() {

    const [items, setItems] = useState([
        {
            id: 1,
            title: 'Titre 1',
            image: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod.'
        },
        {
            id: 2,
            title: 'Titre 2',
            image: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod.'
        },
        {
            id: 3,
            title: 'Titre 3',
            image: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod.'
        }
    ])

    const [partenariats, setPartenariats] = useState([
        {
            id: 1,
            title: 'Entreprise 1',
            logo: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod., ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod'
        },
        {
            id: 2,
            title: 'Entreprise 2',
            logo: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod., ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod'
        },
        {
            id: 3,
            title: 'Entreprise 3',
            logo: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod., ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod'
        }
    ])

    return (
        <LandingWrapper>
            <Header />
            <Actualite />
            <div className="we-trust-us">
                <div className="we-trust-us__title">Ils nous font confiance</div>
                <WeTrustUs partenariats={partenariats} />
            </div>
        </LandingWrapper>
    )
}

const Header = () => {
    return (
        <React.Fragment>
            <div className="landing-reference__body-content">
                <div className="flip-header-reference">
                    <div className="landing-reference__body-content-left-title">
                        <h1>Les clients et les références</h1>
                        <p>de notre offre de signature</p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const Card = ({ items }) => {
    return (
        <React.Fragment>
            <div className="reference-card">
                <div className="reference_card_img"></div>

                <div className="reference_card_content">
                    <div className="reference_card_tile">{items.title}</div>
                    <div className="reference_card_description">{items.description}</div>
                </div>
            </div>
        </React.Fragment>
    )
}

const Actualite = () => {
    return (
        <div className="landing-actualite">
            <p className="landing-partenaire__title"></p>
            <div className="landing-actualite__content">
                <ActualiteItem />
                <ActualiteItem />
                <ActualiteItem />
                <div style={{ marginLeft: '18px' }} className="we-trust-us_content-direction">
                    <BsArrowRight color='white' />
                </div>
            </div>

        </div>
    )
}

const ActualiteItem = () => {
    return (
        <div className="landing-actualite_items">
            <img src='./assets/media/home_icon/actu.jpg' className="landing-actualite_items-img" />

            <div className="landing-actualite_items-content">
                <div className="landing-actualite_items-content-description">Little desx</div>
                <div className="landing-actualite_items-content-title">Lorem ipsum dolor sit</div>

                <div className="landing-actualite_items-content-profile">
                    <FaUserCircle className="landing-actualite_items-content-profile-img" />
                    <div className="landing-actualite_items-content-profile-content">
                        <div className="landing-actualite_items-content-profile-content-name">Lorem ipsum</div>
                        <div className="landing-actualite_items-content-profile-content-date">Mars 28, 2023</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Line = () => {
    return (
        <React.Fragment>
            <img src="./assets/media/home_icon/line-dkbsign.png" alt="reference-line" className='reference-line' />
        </React.Fragment>
    )
}

const WeTrustUs = ({ partenariats }) => {
    const [index, setIndex] = useState(0)
    const [current, setCurrent] = useState(partenariats[0])

    return (
        <React.Fragment>
            <div className="we-trust-us_content">
                <div
                    onClick={() => {
                        if (index > 0) {
                            setIndex(index - 1)
                            setCurrent(partenariats[index - 1])
                        }
                    }}
                    className="we-trust-us_content-direction">
                    <BsArrowLeft color='white' />
                </div>
                <Partenaire items={current} />
                <div
                    onClick={() => {
                        if (index < partenariats.length - 1) {
                            setIndex(index + 1)
                            setCurrent(partenariats[index + 1])
                        }
                    }}
                    className="we-trust-us_content-direction">
                    <BsArrowRight color='white' />
                </div>
            </div>
        </React.Fragment>
    )
}

const Partenaire = ({ items }) => {
    return (
        <React.Fragment>
            <div className="partenaire">
                <div className="partenaire-logo">{items.title}</div>
                <div className="partenaire-description">{items.description}</div>
            </div>
        </React.Fragment>
    )
}